import { FC } from "react";
import { User } from "@auth0/auth0-spa-js";
import { LogoutFunction } from "./types";
import config from "../config";


import { AppHeaderComponent, InfoCircleOutlined, QuestionCircleOutlined } from "@aer-lib/components";

interface IAppHeader {
  user?: User;
  logout: LogoutFunction;
}

const LandingPageHeader: FC<IAppHeader> = ({ user = {}, logout }) => {
  const { name = "", picture = "" } = user;
  const isInternalUser = user["https://schema.aer.ca/userType"] === "internal";
  const primaryBaName = user["https://schema.aer.ca/primaryBaName"];
  const primaryBaId = user["https://schema.aer.ca/primaryBaId"];

  return isInternalUser ? (
    <AppHeaderComponent
      toolTipTitle={"Learn More"}
      ExternalInfoIcon={
        <QuestionCircleOutlined
          data-testid="app-header-info-icon"
          style={{ color: "white", fontSize: "xx-large" }}
        />
      }
      ExternalInfoIconHref={config.internalHelpLink}
      user={{ name, picture }}
      logout={logout}

    />
  ) : (
    <AppHeaderComponent
      toolTipTitle={"Learn More"}
      ExternalInfoIcon={
        <InfoCircleOutlined
          data-testid="app-header-info-icon"
          style={{ color: "white", fontSize: "xx-large" }}
        />
      }
      ExternalInfoIconHref={config.externalHelpLink}
      user={{ name, picture, primaryBaName, primaryBaId }}
      logout={logout}
    />
  );
};

export default LandingPageHeader;